import DashboardScreen from "./Dashboard";
import ExpensesScreen from "./Expenses";
import RecipesScreen from "./Recipes";
import SettingsPage from "./Settings";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  DashboardScreen,
  ExpensesScreen,
  RecipesScreen,
  SettingsPage,
};
